export default {"src":"/_next/static/media/plus-small.ee10caf4.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};